document.addEventListener("DOMContentLoaded", () => {
  const scroll = localStorage.getItem("restoreScroll");
  const shouldOpen = localStorage.getItem("openDrawerAfterReload");

  if (scroll) {
    window.scrollTo(0, parseInt(scroll));
    localStorage.removeItem("restoreScroll");
  }

  if (shouldOpen === "true") {
    let attempts = 0;

    const tryOpenDrawer = () => {
      const drawer = document.querySelector("cart-drawer") || document.getElementById("CartDrawer");

      if (drawer) {
        drawer.classList.add("is-open", "active");
        document.getElementById("CartDrawer-Overlay")?.classList.add("is-visible");
        if (typeof drawer.open === "function") {
          drawer.open();
        }
        localStorage.removeItem("openDrawerAfterReload");
      } else if (attempts < 10) {
        attempts++;
        setTimeout(tryOpenDrawer, 300);
      } else {
        localStorage.removeItem("openDrawerAfterReload");
      }
    };

    tryOpenDrawer();
  }
});